import axiosInstance from '../utils/axiosConfig';

export interface UserProfile {
  username: string;
  nickname: string;
  email: string;
  phone: string;
  created_at: string;
  subscription_months: number;
  expiry_date: string | null;
}

export interface UpdateProfileData {
  nickname?: string;
  email?: string;
  phone?: string;
}

export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await axiosInstance.get('/auth/profile');
  return response.data;
};

export const updateProfile = async (data: UpdateProfileData): Promise<{ message: string }> => {
  const response = await axiosInstance.put('/auth/profile', data);
  return response.data;
};

export const getUserStats = async () => {
  const response = await axiosInstance.get('/user/stats');
  return response.data;
};

export const getUserHistory = async () => {
  const response = await axiosInstance.get('/user/history');
  return response.data;
}; 